import { StrictMode, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { initEnv } from 'kmstack-shared/core';
import { applyThemeColors, createTheme } from 'kmstack-shared/constants';
import { AlertProvider, AuthProvider, KmstackProvider, BrowserWebSocketProvider } from 'kmstack-shared/providers';
import { TrackingProvider } from 'kmstack-shared/tracking';
import App from './App'
import './main.css'
import './styles/checkbox.css'
import { PaymentService } from './features/billing/services/payment.service'
import { persistor, store } from './utils/store'
import { setupSpinner } from 'kmstack-shared/components/basic'
import { cn } from './utils/utils.types'

const isProd = import.meta.env.PROD
applyThemeColors(createTheme());
initEnv(import.meta.env);

// Initialize API client with auth app configuration
// Initialize services that depend on the environment configuration.
// TODO: this should not be here, it should be in the app, because it depends on the environment configuration.
PaymentService.initializeStripe();
PaymentService.initializePayPal();
setupSpinner(cn)

function Root() {
    const [queryClient] = useState(() => new QueryClient())

    return (
        <StrictMode>
            <AlertProvider>
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor!}>
                        <KmstackProvider dispatch={store.dispatch} getState={() => store.getState()}>
                            {/* use value from config */}
                                {/* TODO: this should be improved so that it not making an api call on every refresh */}
                                <TrackingProvider types={['geo']}>
                                    <QueryClientProvider client={queryClient}>
                                        <AuthProvider>
                                            <BrowserWebSocketProvider>
                                                <App />
                                            </BrowserWebSocketProvider>
                                        </AuthProvider>
                                    </QueryClientProvider>
                                </TrackingProvider>
                        </KmstackProvider>
                    </PersistGate>
                </Provider>
            </AlertProvider>
        </StrictMode>
    )
}

createRoot(document.getElementById('root')!).render(<Root />)
